import {useMutation} from "react-query";
import apis from "services";
import {get} from "lodash";

export default function useFetchSentList() {

    const {
        data: sentListResponse,
        mutate: fetchSentList,
        isLoading: fetchingSentList
    } = useMutation('sent_list', apis.sendListApi);

    const _sentList = get(sentListResponse, 'data', []);

    return [fetchSentList, fetchingSentList, _sentList];
}